module.exports = __webpack_public_path__ + "static/headshot-8c11ae35ec2b00ec09d38cc91282bee3.png";